import { Outlet } from "react-router-dom";
import Header from "../components/header/header";
import SideBar from "../components/sidebar/sidebar";
import { useState } from "react";
const Layout = () => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <div className="h-full grid grid-cols-[auto_1fr] ">
        <div className="h-auto ">
          <SideBar setOpen={setOpen} open={open} />
        </div>
        <div className="min-h-screen text-white bg-mainBg">
          <Header setOpen={setOpen} open={open} />
          <div className="p-4">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
